/**
 * KnowledgeBaseStatusService
 * Route: api/knowledge-base-statuses
 */
import { BaseService } from '../base/BaseService';
export class KnowledgeBaseStatusService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? KnowledgeBaseStatusService.DEFAULT_SERVICE_PATH,
            basePath: KnowledgeBaseStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    getAllRaw() {
        return this.http.get(this.buildUrl(''));
    }
    async getById(id) {
        const response = await this.http.get(this.buildUrl(`${id}`));
        return response.data ?? null;
    }
    async create(item) {
        const response = await this.http.post(this.buildUrl(''), item);
        return response.data ?? null;
    }
    async update(id, item) {
        const response = await this.http.put(this.buildUrl(`${id}`), item);
        return response.data ?? null;
    }
    async delete(id) {
        const response = await this.http.delete(this.buildUrl(`${id}`));
        return response.success;
    }
}
KnowledgeBaseStatusService.DEFAULT_SERVICE_PATH = 'resources';
KnowledgeBaseStatusService.BASE_PATH = 'api/knowledge-base-statuses';
//# sourceMappingURL=KnowledgeBaseStatusService.js.map